import { z } from 'zod';

export const TranslationsSchema = z.record(
  z.string(),
  z.union([
    z.array(z.unknown()),
    z.record(z.string(), z.union([z.string(), z.array(z.unknown()), z.record(z.string(), z.unknown())])),
  ]),
);

export const TranslationGroupSchema = z.object({
  iso: z.string(),
  name: z.string(),
  translations: TranslationsSchema,
});

export const AllTranslationsResponseSchema = z.array(TranslationGroupSchema);

export type Translations = z.infer<typeof TranslationsSchema>;
export type TranslationGroup = z.infer<typeof TranslationGroupSchema>;
